<template>
    <div>
        <a-modal :title="ModalText" width="408px" centered :visible="visible" :confirm-loading="confirmLoading" @cancel="handleCancel">
            <div class="form">

                <div class="sub-title">老师头像</div>
                <div class="avatar-wrapper">
                    <div class="avatar" @click="selectAvatar">
                        <img v-if="params.avatar" :src="params.avatar" />
                        <img v-else src="/assets/icons/icon-add-teacher.png" />
                    </div>
                    <div class="right">
                        <div class="avatar-select" @click="selectAvatar" v-if="params.avatar">更换</div>
                        <div class="avatar-tips">
                            <div>图片格式必须为：png,bmp,jpeg,jpg,gif；</div>
                            <div>图片大小不能超过2MB；</div>
                        </div>
                    </div>
                </div>

                <div class="sub-title">老师名称</div>
                <div class="content-wrapper">
                    <input type="text" class="input" maxLength="6" v-model="params.name" placeholder="请输入不超过6字的名称" />
                    <div class="input-length">{{ params.name.length }}/6</div>
                </div>

                <div class="sub-title">老师简介</div>
                <div class="content-wrapper" style="height: 150px;">
                    <textarea maxLength="120" v-model="params.summary" placeholder="请输入不超过120字的简介" />
                    <div class="input-length textarea-length">{{ params.summary.length }}/120</div>
                </div>
            </div>
            <div slot="footer" class="footer">
                <div class="cancel" @click="handleCancel">取消</div>
                <div class="submit" @click="handleOk">确定</div>
            </div>
        </a-modal>
        <input type="file" ref="fileInput" style="display: none" accept="image/*" @change="handleFileChange" />
        <avatar-cropper 
            v-model="showCropperModal" 
            :image="cropperImageSrc" 
            @cropped="handleCropped" 
            :aspectRatio="1"
        />
    </div>
</template>

<script>
import api from '@/repo/api';
import AvatarCropper from '@/components/AvatarCropper.vue';
import { UploadImage } from '@/utils/upload.js';

export default {
    name: 'TeacherCreate',
    components: {
        AvatarCropper
    },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            ModalText: '新增项目老师',
            params: {
                name: '',
                avatar: '',
                summary: '',
            },
            showCropperModal: false,
            cropperImageSrc: ''
        }
    },
    methods: {
        open(record = null) {
            console.log('接收到的record参数:', record);
            // 先关闭弹窗，确保状态正确
            this.visible = false;
            
            // 延迟重置表单，确保DOM更新
            this.$nextTick(() => {
                // 重置表单（不直接替换整个对象，避免响应式问题）
                this.params.name = '';
                this.params.avatar = '';
                this.params.summary = '';
                
                // 如果是编辑模式，填充数据
                if (record) {
                    this.ModalText = '修改项目老师';
                    // 逐个设置属性，确保Vue能够响应变化
                    this.params.id = record.id;
                    this.params.name = record.name || '';
                    this.params.avatar = record.avatar || '';
                    this.params.summary = record.summary || '';
                    console.log('编辑模式下的params数据:', this.params);
                } else {
                    this.ModalText = '新增项目老师';
                    delete this.params.id;
                }
                
                // 所有数据更新完成后，再显示弹窗
                this.$nextTick(() => {
                    this.visible = true;
                    console.log('打开弹窗后的visible状态:', this.visible);
                });
            });
        },
        close() {
            this.visible = false;
        },
        handleOk() {
            // 表单验证
            if (!this.params.avatar) {
                this.$message.error('请上传老师头像');
                return;
            }
            if (!this.params.name.trim()) {
                this.$message.error('请输入老师名称');
                return;
            }
            if (!this.params.summary.trim()) {
                this.$message.error('请输入老师简介');
                return;
            }
            
            this.$loading.show();
            
            api.post('/ast-appointment/teacher-sync', this.params).then(res => {
                this.$loading.hide();
                if (res.code === 0) {
                    this.$message.success('已成功保存，手机端须重新进入小程序方可生效');
                    this.close();
                    // 通知父组件刷新列表
                    this.$emit('created');
                } else {
                    this.$message.error(res.msg || '操作失败');
                }
            }).catch(() => {
                this.$loading.hide();
                this.$message.error('操作失败');
            })
        },
        handleCancel() {
            console.log('Clicked cancel button');
            this.visible = false;
        },
        changeAvatar(url) {
            this.params.avatar = url;
        },
        selectAvatar() {
            this.$refs.fileInput.click();
        },
        handleFileChange(e) {
            const file = e.target.files[0];
            if (!file) return;

            // 检查文件大小不超过2MB
            if (file.size > 2 * 1024 * 1024) {
                this.$message.error('图片大小不能超过2MB');
                return;
            }

            // 读取文件并显示裁剪模态框
            const reader = new FileReader();
            reader.onload = (event) => {
                this.cropperImageSrc = event.target.result;
                this.showCropperModal = true;
            };
            reader.readAsDataURL(file);

            // 清空input，以便可以重复选择同一个文件
            e.target.value = '';
        },
        async handleCropped(data) {
            this.$loading.show();
            try {
                // 将base64转换为file对象
                const file = this.dataURLtoFile(data, 'avatar.png');
                // 使用UploadImage类上传图片
                const uploader = new UploadImage({ usage: 'teacher_avatar' });
                const result = await uploader.upload(file);
                // 上传成功后设置服务器返回的URL
                this.params.avatar = result.url;
                this.$message.success('头像上传成功');
            } catch (error) {
                console.error('头像上传失败:', error);
                this.$message.error('头像上传失败，请重试');
            } finally {
                this.$loading.hide();
            }
        },
        
        // Base64字符串转File文件
        dataURLtoFile(dataurl, filename) {
            let arr = dataurl.split(',');
            let mime = arr[0].match(/:(.*?);/)[1];
            let bstr = atob(arr[1]);
            let n = bstr.length;
            let u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },

    }
}
</script>

<style lang="scss" scoped>
input,
textarea {

    border: none;
    outline: none;
    padding: 0;
    margin: 0;

    &::placeholder {
        color: rgba(0, 0, 0, 0.25);
    }
}

.sub-title {
    font-size: 14px;
    color: #333333;
    margin-bottom: 16px;
}

.avatar-wrapper {
    display: flex;
    align-items: flex-end;
    margin-bottom: 24px;

    /deep/ .ant-upload.ant-upload-select-picture-card {
        margin: 0 !important;
    }

    .avatar {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }

    .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 16px;
        .avatar-select {
            font-size: 14px;
            color: #FBB03B;
            line-height: 20px;
            cursor: pointer;
        }
        .avatar-tips {
            font-size: 12px;
            color: #999999;
            line-height: 20px;
        }
    }
}

.content-wrapper {
    width: 100%;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #D9D9D9;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    position: relative;

    .input,
    textarea {
        flex: 1;
        height: 100%;
        font-size: 14px;
        color: #333333;
    }

    textarea {
        resize: none;
    }

    .input-length {
        color: rgba(0, 0, 0, 0.25);
        font-size: 14px;
        line-height: 20px;
    }

    .textarea-length {
        position: absolute;
        bottom: 10px;
        right: 16px;
    }
}

.footer {
    display: flex;
    align-items: center;
    justify-content: center;

    div {
        width: 72px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        cursor: pointer;
    }

    .cancel {
        color: #333333;
        background: #FFFFFF;
        border: 1px solid #333333;
        margin-right: 16px;
    }

    .submit {
        color: #fff;
        background: #333333;
    }
}
</style>
